export default "__VITE_ASSET__yROosPay__"